<template>
  <v-layout row wrap class="ch-info-component">
    <v-flex xs12 class="pt-0">
      <v-card>
        <v-card-title class="head">
          <span class="info-name ml-2">HOTEL PERMISSIONS</span>
        </v-card-title>
        <v-card-text class="body padding">
          <v-layout row wrap class="permission">
            <v-flex 
              xs3
              v-for="permissionItem in permissionItems"
              :key="permissionItem.id"
            >
              <div class="form-checkbox">
                <div class="checkbox-wrapper">
                  <v-checkbox 
                    :label="getRoleString(permissionItem.role)" 
                    v-model="permissions" 
                    :value="permissionItem.id"
                    hide-details
                  ></v-checkbox>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <div class="btn-wrapper">
            <v-spacer></v-spacer>
            <button
              class="save"
              @click="this.updateHotelPermission"
            >
              <i class="fas fa-save fa-fw"></i>
              <span>SAVE</span>
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import PermissionModel from '../../../permissions';
  import api from '../../../api';

  export default {
    data() {
      return {
        // id: null,
        permissionItems: [],
        permissions: [],
      };
    },
    methods: {
      getPermission() {
        api.getPermission()
        .then((result) => {
          if (result.status === 200) {
            this.permissionItems = result.data.filter(r => r.type === 'igrms' || r.type === 'staffapp');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getRoleString(role) {
        return PermissionModel.getRoleString(role);
      },
      /**
       * @description 선택된 checkbox의 아이디값을 새 배열로 반환
       * @returns { Array } permissions
       */
      getPermissions() {
        return this.permissions.filter(item => (item !== undefined) && (item !== null) && item !== '');
      },
      getHotelPermission() {
        const id = this.id;
        api.getHotelPermission(id)
        .then((result) => {
          this.permissions = result.data.map(item => item.id);
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      updateHotelPermission() {
        const id = this.id;
        const param = this.getPermissions();
        api.updateHotelPermission(id, param)
        .then((result) => {
          // console.log(`updateHotelPermission: ${result.data}`);
          this.permissions = result.data.map(item => item.id);
          this.alert.type = 'check_circle';
          this.alert.color = 'green';
          this.alert.message = 'Success update';
          this.alertOccur();
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getPermission();
      this.getHotelPermission();
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/hotels/HotelsPermission.vue